const READING_ROOTS = new Set([
  "guides",
  "blog",
  "news",
  "openings",
  "learn",
  "beginners",
  "chess-basics",
  "chess-history",
  "chess-variants",
  "endgames",
  "famous-games",
  "how-to-play",
  "strategy",
  "tactics",
]);

function routeParts(path: string): string[] {
  const pathname = path.split(/[?#]/, 1)[0];
  const parts = pathname.split("/").filter(Boolean);
  if (/^[a-z]{2}(?:-[A-Z]{2})?$/.test(parts[0] || "")) {
    parts.shift();
  }
  return parts;
}

export function isReadingRoute(path: string): boolean {
  return READING_ROOTS.has(routeParts(path)[0]);
}
